<div
  class="color-picker-component"
  [ngClass]="{ 'template-color-picker-style': currentPage?.currentPage === 'templates' }"
>
  <div class="color-picker-component-header" *ngIf="currentPage?.currentPage !== 'templates'">
    <span class="property-color-indicator" [ngStyle]="{ 'background-color': selectedColor }"></span>
    <span>
      {{ selectedColor || color }}
    </span>
    <p-button
      icon="pi pi-pencil"
      styleClass="p-button-rounded p-button-text"
      (onClick)="op.show($event); repositon($event)"
      *ngIf="!disableField"
    />
  </div>
  <span
    #btn
    class="template-color-picker-body"
    [ngStyle]="{ 'background-color': selectedColor }"
    tabindex="0"
    (click)="op.show($event, body); selectColor(element?.defaultValue)"
    (keyup.enter)="op.show($event, body); selectColor(element?.defaultValue)"
    *ngIf="currentPage?.currentPage === 'templates'"
    role="button"
    aria-label="Select color popup"
  ></span>
  <p-popover #op styleClass="color-picker-overlay p-overlaypanel-flipped" (onShow)="repositon($event)">
    <ng-template #content>
      <div class="cp-overlay">
        <div class="predefined-colors">
          <span
            *ngFor="let pcolor of predefinedColors"
            [ngStyle]="{ 'background-color': pcolor?.hex }"
            tabindex="1"
            [ngClass]="{ active: pcolor?.hex === selectedColor || pcolor.hsl === selectedColor }"
            (click)="selectColor(pcolor)"
            (keyup.enter)="selectColor(pcolor)"
            role="button"
            aria-label="Select color"
          ></span>
        </div>
        <div class="row align-items-center">
          <div class="col-12">
            <span
              [(colorPicker)]="color"
              [cpToggle]="true"
              [style.background]="color"
              [cpDialogDisplay]="'inline'"
              (colorPickerChange)="changeColor()"
              *ngIf="currentPage?.currentPage !== 'templates'"
            ></span>
            <span
              [(colorPicker)]="color"
              [cpToggle]="true"
              [style.background]="color"
              [cpDialogDisplay]="'inline'"
              (colorPickerChange)="changeColor()"
              [cpAlphaChannel]="'disabled'"
              *ngIf="currentPage?.currentPage === 'templates'"
              [cpOutputFormat]="'hex'"
            ></span>
          </div>
        </div>
        <div class="button-group text-right mt-2">
          <button type="button" class="btn btn-sm btn-secondary mr-1" (click)="cancelSelColor($event, op)">
            Cancel
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="saveSelectedColor($event, op)">Save</button>
        </div>
      </div>
      <span class="custom-arrow"></span>
    </ng-template>
  </p-popover>
</div>
